import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import ReactResizeDetector from 'react-resize-detector';
import { Box } from '@material-ui/core';
import useStyles from './styles';
import Loading from './Loading';

import { usePrevious } from '../../../../utils';
import SectionCard from '../../../../components/SectionCard';

const Description = props => {
  const { onSectionChange } = props;
  const classes = useStyles();
  const { current, list } = useSelector(state => state.course);
  const [loading, setLoading] = React.useState(true);
  const [description, setDescription] = React.useState('');
  const prevDescription = usePrevious(description);

  const normalizeDescription = React.useCallback(desc => {
    if (desc && desc.includes('vimeo')) {
      if (desc.includes('&controls=0')) {
        return desc.replace('&controls=0', '');
      }
      if (desc.includes('?controls=0&')) {
        return desc.replace('?controls=0&', '?');
      }
      if (desc.includes('?controls=0')) {
        return desc.replace('?controls=0', '');
      }
    }
    return desc;
  }, []);

  React.useEffect(() => {
    setLoading(true);
  }, [current]);

  React.useEffect(() => {
    if (!current || !list[current.course]?.courseDetailed) return;
    const hasCourse = current?.course in list;
    const hasLesson = current?.lesson in list[current.course]?.lessons;
    if (hasCourse && hasLesson) {
      const { content, description: descLesson } = list[current.course].lessons[
        current.lesson
      ];
      const lessonDescription = descLesson
        ? descLesson.concat(content)
        : content;
      if (prevDescription !== lessonDescription) {
        setDescription(normalizeDescription(lessonDescription));
      }
      setLoading(false);
    }
  }, [current, list, normalizeDescription, prevDescription]);

  React.useEffect(() => {
    const toRender = !!description;
    onSectionChange('render', toRender);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [description]);

  const createMarkup = () => ({ __html: description });

  // 1 - padrao theme
  // 2 - light
  // 3 - dark
  const forceBackground = useCallback(() => {
    if (list[current.course] && list[current.course].courseDetailed) {
      if (!list[current.course].lessons[current.lesson]) return false;
      const { defaultContentTheme } = list[current.course].lessons[
        current.lesson
      ];
      switch (defaultContentTheme) {
        case 2:
          return 'light';
        case 3:
          return 'dark';
        case 1:
        default:
          return false;
      }
    }
    return false;
  }, [current, list]); // false, light or dark

  return loading ? (
    <SectionCard className="container-section" id="content">
      <Loading />
    </SectionCard>
  ) : (
    <>
      {description ? (
        <SectionCard className="container-section" id="content">
          <ReactResizeDetector
            handleHeight
            onResize={(width, height) => onSectionChange('height', height)}
          />
          <Box className={`${classes.container} ${forceBackground() || ''}`}>
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={createMarkup()} />
          </Box>
        </SectionCard>
      ) : null}
    </>
  );
};

export default Description;
